import script from "./AreaRadarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./AreaRadarChart.vue?vue&type=script&setup=true&lang=js"

import "./AreaRadarChart.vue?vue&type=style&index=0&id=a455ae56&lang=less"

const __exports__ = script;

export default __exports__